
export default function AppScreenshot({ title, imgSrc, ...props }) {
  return (
    <div className="app-screenshot m-3">
      <img src={imgSrc} alt={title} {...props} />
    </div>
  );
}
